const Footer = () => (
  <footer className="text-center py-3 bg-dark text-secondary">
    © {new Date().getFullYear()} Two Dawgs DJ — All Rights Reserved
  </footer>
);

export default Footer;
